<script setup>
defineOptions({ name: "SupportHorariosSection" });

const schedules = [
  { day: "Segunda a sexta-feira", hours: "08h00 – 18h00", available: true },
  { day: "Sábado", hours: "08h00 – 12h00", available: true },
  { day: "Domingo e feriados", hours: "Indisponível", available: false },
];

const slaItems = [
  { priority: "Alta", label: "Resposta em até", time: "2 horas" },
  { priority: "Média", label: "Resposta em até", time: "4 horas" },
  { priority: "Baixa", label: "Resposta em até", time: "1 dia útil" },
];

// Revela o elemento com fade+slide assim que ele entra na viewport ao rolar a página.
const vReveal = {
  mounted(el) {
    el.classList.add("reveal-init");
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("reveal-visible");
          io.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
    );
    io.observe(el);
  },
};
</script>

<template>
  <section id="horarios" class="py-16 bg-white scroll-mt-24">
    <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div v-reveal class="max-w-2xl">
        <h2
          class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b]"
        >
          Horários de atendimento
        </h2>
      </div>

      <div class="grid gap-10 mt-6 lg:grid-cols-2 lg:items-start">
        <div v-reveal>
          <p class="text-base text-gray-600 sm:text-lg">
            Planeje seu contato com nosso time.
          </p>

          <div
            class="overflow-hidden mt-8 rounded-2xl border border-gray-200 divide-y divide-gray-100"
          >
            <div
              v-for="s in schedules"
              :key="s.day"
              class="flex justify-between items-center px-6 py-4 bg-white"
            >
              <span class="text-sm font-medium text-gray-700">{{ s.day }}</span>
              <span
                :class="
                  s.available
                    ? 'text-sm font-semibold text-[#006086]'
                    : 'text-sm text-gray-400'
                "
              >
                {{ s.hours }}
              </span>
            </div>
          </div>
        </div>

        <div v-reveal class="p-8 bg-[#e6f0f4] rounded-2xl">
          <h3 class="text-lg font-semibold text-gray-900">Tempo de resposta</h3>
          <p class="mt-1 text-sm text-gray-600">
            Dentro do horário de atendimento:
          </p>
          <div class="mt-6 space-y-4">
            <div
              v-for="sla in slaItems"
              :key="sla.priority"
              class="flex justify-between items-center"
            >
              <div class="flex gap-2 items-center">
                <span
                  :class="{
                    'bg-red-100 text-red-700': sla.priority === 'Alta',
                    'bg-amber-100 text-amber-700': sla.priority === 'Média',
                    'bg-green-100 text-green-700': sla.priority === 'Baixa',
                  }"
                  class="px-2 py-0.5 text-xs font-semibold rounded-full"
                >
                  {{ sla.priority }}
                </span>
                <span class="text-sm text-gray-600">{{ sla.label }}</span>
              </div>
              <span class="text-sm font-bold text-gray-900">{{
                sla.time
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.reveal-init {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal-init {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
